import { createFeatureSelector, createSelector } from '@ngrx/store';
import { EffectLoadingState } from '../shared/models/effect-state';
import { equipmentFeatureKey, EquipmentState } from './equipment.reducer';

export const equipmentState =
    createFeatureSelector<EquipmentState>(equipmentFeatureKey);

export const selectEquipment = createSelector(
    equipmentState,
    (state) => state.equipment
);

export const selectActiveEquipment = createSelector(
    equipmentState,
    selectEquipment,
    (state, equipment) =>
        equipment.find((equip) => equip.id === state.activeEquipmentId)
);

export const selectUpdateEquipmentLoading = createSelector(
    equipmentState,
    (state) =>
        state.equipmentUpdateState.effectState === EffectLoadingState.Loading
);

export const selectDeleteEquipmentLoading = createSelector(
    equipmentState,
    (state) =>
        state.equipmentDeleteState.effectState === EffectLoadingState.Loading
);

export const selectEditEquipmentLoading = createSelector(
    selectUpdateEquipmentLoading,
    selectDeleteEquipmentLoading,
    (isUpdateLoading, isDeleteLoading) => isUpdateLoading || isDeleteLoading
);

export const selectUpdateEquipmentResult = createSelector(
    equipmentState,
    (state) => state.equipmentUpdateState
);

export const selectDeleteEquipmentResult = createSelector(
    equipmentState,
    (state) => state.equipmentDeleteState
);
